<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Canteen Daily Meal History</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="3">
                        <p><b>From Date(Inclusive)</b></p>
                        <v-text-field outlined dense type="date" v-model="fromdate"
                            label="From Date(Inclusive)"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                        <p><b>To Date(Exclusive)</b></p>
                        <v-text-field outlined dense type="date" v-model="todate"
                            label="To Date(Exclusive)"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2" class="pt-4" v-if="fromdate && todate">
                        <br />
                        <v-btn color="brand onBrand--text" @click="getCanteenDailyMealHistory()">Fetch</v-btn>
                    </v-col>
                </v-row>
            </v-card>

            <v-card class="box" v-if="canteen_daily_meal_history_data != ''">
                <v-row>
                    <v-col cols="12" sm="6" md="6">
                        <v-btn rounded color="success" outlined
                            @click="fnExcelReport('my-table-id', 'CanteenDailyMealHistory')" :loading="loader"><v-icon
                                color="success">mdi-export</v-icon>Export</v-btn>
                    </v-col>

                    <v-col cols="12" sm="6" md="6">
                        <v-text-field v-model="search" append-icon="search" label="Search" single-line
                            hide-details></v-text-field>
                    </v-col>
                </v-row>




                <div id="my-table-id">
                    <v-data-table :headers="headers" :items="bookList1" :search="search" class="elevation-1 mytable"
                        dense v-if="canteen_daily_meal_history_data != ''" @current-items="getFiltered">
                        <template v-slot:top class="pb-5">
                            <v-row dense justify="center" align="center">
                                <tr class="t-row">
                                    <v-toolbar flat class="toolbar">
                                        <v-toolbar-title>Canteen Daily Meal History List</v-toolbar-title>
                                        <v-divider class="mx-4" inset vertical></v-divider>
                                        <v-spacer></v-spacer>

                                    </v-toolbar>
                                    <div>
                                        <th>
                                            <v-row dense>
                                                <span v-for="header in headers" :key="header.text">
                                                    <span v-if="filters.hasOwnProperty(header.value)">
                                                        <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small
                                                            rounded dense outlined color="#0F2027" :label="header.text"
                                                            multiple clearable :items="columnValueList(header.value)"
                                                            v-model="filters[header.value]"></v-autocomplete>
                                                    </span>
                                                </span>
                                            </v-row>
                                        </th>
                                    </div>
                                </tr>
                            </v-row>
                        </template>

                    </v-data-table>
                </div>
            </v-card>
        </v-container>
    </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
        loader: false,
        snackbar_msg: "",
        color: "",
        // extraBreadcrumbItems: [


        // ],
        // breadcrumbClass: "breadcrumb-style1",
        search: "",
        snackbar: false,
        overlay: false,
        fromdate: new Date().toISOString().slice(0, 10),
        todate: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1).toISOString().substr(0, 10),
        headers: [
            { text: "SR No", value: "count" },
            { text: "Date", value: "date" },
            { text: "PRN", value: "prn" },
            { text: "Student", value: "learner" },
            { text: "Menu Taken", value: "canteenmenutype" },
            { text: "Standard", value: "standard" },
            { text: "Division", value: "division" },
            { text: "Roll No", value: "roll_no" },
        ],
        filterArr: [],
        filters: {

            prn: [],
            standard: [],
            division: [],
            learner: [],
            roll_no: [],
            canteenmenutype: [],
        },
        table_fields: {
            "Sr. No": "count",
            "Date": "date",
            "PRN No.": "prn",
            Student: "learner",
            "Menu Taken": "canteenmenutype",
            Standard: "standard",
            Division: "division",
            "Roll No": "roll_no",
        },
        canteen_daily_meal_history_data: []
    }),
    methods: {
        fnExcelReport(id, name) {
            let tab_text = `<table border='1px'>
    <tr>
      <th>Sr.No</th>
      <th>Date</th>
      <th>PRN</th>
      <th>Student</th>
      <th>Menu Taken</th>
      <th>Standard</th>
      <th>Division</th>
      <th>Roll No</th>
      
      
    </tr>`;

            this.canteen_daily_meal_history_data.forEach((item, index) => {
                tab_text += `
    <tr>
        <td>${item.count}</td> 
        <td>${item.date}</td>
        <td>${item.prn}</td>
        
        <td>${item.learner}</td>
        <td>${item.canteenmenutype}</td>
        <td>${item.standard}</td>
        <td>${item.division}</td>
        <td>${item.roll_no}</td>
        
    </tr>`;
            });

            tab_text += '</table>';

            const blob = new Blob([tab_text], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // For IE
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                // For modern browsers
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }
        },
        getFiltered(e) {
            this.filterArr = e;
        },
        columnValueList(val) {
            return this.canteen_daily_meal_history_data.map((d) => d[val]);
        },

        ExportToExcel() {
            var htmltable = document.getElementById("my-table-id");
            var html = htmltable.outerHTML;
            window.open("data:application/vnd.ms-excel," + encodeURIComponent(html));
        },

        getCanteenDailyMealHistory() {
            const data = {
                fromdate: this.fromdate,
                todate: this.todate,
            };
            this.overlay = true;
            axios
                .post("/Canteen/getCanteenDailyMealReport", data)
                .then((res) => {
                    this.overlay = false;
                    if (res.data.flag == "YES") {
                        this.canteen_daily_meal_history_data = res.data.canteen_meal_history;
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
    computed: {
        bookList1() {
            return this.canteen_daily_meal_history_data.filter((d) => {
                return Object.keys(this.filters).every((f) => {
                    return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                });
            });
        },
    },
    mounted() {
        // this.onLoad();
    },
    watch: {},
};
</script>
<style scoped></style>